import React from 'react';

// import { TableCell, TableRow, Typography } from '@material-ui/core';

import { IMaterialDataTableItem, TValidContentTypes, IWithActionButtonProps } from '../../prop-types';
import TableRow from '../table/TableRow';
import TableCell from '../table/TableCell';
import ConfirmationIcons from '../ActionIcons/ConfirmationIcons';

interface IDeleteRowProps extends IWithActionButtonProps {
  cells: IMaterialDataTableItem<TValidContentTypes>[];
  onConfirm: () => void;
  onCancel: () => void;
}
export default function DeleteRow({
  cells,
  onConfirm,
  onCancel,
  ...props
}: IDeleteRowProps) {
  return (
    <TableRow>
      <TableCell>
        <ConfirmationIcons onConfirm={onConfirm} onCancel={onCancel} {...props} />
      </TableCell>
      <TableCell colspan={cells.length}>
        <h6>
          Wollen Sie diesen Eintrag wirklich löschen?
        </h6>
      </TableCell>
    </TableRow>
  );
}
